module.exports = __webpack_public_path__ + "img/UTDEER-5.c2ccbf7c.jpg";